<script lang="ts" setup>
import { ref, computed, Ref } from "vue";
import { useApiStore, type WpProject } from "@/stores/api";
//@ts-ignore
import projectGridCard from "./elements/project-grid-card.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

const apiStore = useApiStore();

const breakpoints = useBreakpoints(breakpointsTailwind);
const ShowMobileGrid = breakpoints.smaller("lg");

const projects: Ref<WpProject[]> = ref([]);

apiStore.getWpProjects({ per_page: 20, last_chance: 1 }).then((p: WpProject[]) => (projects.value = p));

const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};

const projectsSortedByCategory = computed(() => {
    let sortedProjects: Array<WpProject | { id: 0; post_title: "coming-soon" }> = projects.value.sort((a, b) => {
        if (b.category && b.category.find((c) => c.cat_name === "sold")) {
            return -1;
        }
        return 0;
    });

    if (sortedProjects.length > 3) {
        sortedProjects.splice(4, 0, { id: 0, post_title: "coming-soon" });
    } else {
        sortedProjects.push({ id: 0, post_title: "coming-soon" });
    }

    return sortedProjects;
});
</script>

<template>
    <div v-if="!ShowMobileGrid" class="flex flex-row gap-[32px]">
        <div class="flex-[33%] flex flex-col gap-[32px]">
            <template v-for="(item, index) in projectsSortedByCategory">
                <project-grid-card v-if="[0, 3, 6, 9, 12, 15].includes(index) && item.post_title !== 'coming-soon'" :project="item" :key="`col_1_${index}`" :size="index % 2 === 0 ? 'lg' : 'md'"></project-grid-card>
            </template>
        </div>
        <div class="flex-[33%] flex flex-col gap-[32px]">
            <template v-for="(item, index) in projectsSortedByCategory">
                <a v-if="item.post_title === 'coming-soon'" :key="`col_2_cs_${index}`" href="/coming-soon" class="relative flex flex-col h-card-md sm:h-[500px] md:h-card-md lg:h-[400px] cta">
                    <div class="order-1 banner absolute flex z-10 bottom-0 lg:bottom-auto top-0 left-0 w-full h-[56px] items-center justify-center uppercase font-bold bg-gold text-white">Bekijk toekomstige projecten</div>
                    <div class="pb-[0] flex pt-[56px] relative w-full !h-full">
                        <div class="relative flex-1">
                            <img class="p-[32px] bg-[#35322f] lazyload absolute xl:hidden inset-0 w-full h-full object-center object-cover" data-src="/images/coming-soon-350x312.gif" />
                            <img class="p-[32px] bg-[#35322f] lazyload absolute hidden xl:inline inset-0 w-full h-full object-center object-cover" data-src="/images/coming-soon-350x486.gif" />
                        </div>
                    </div>
                </a>
                <project-grid-card v-if="[1, 7, 10, 13, 16].includes(index) && item.post_title !== 'coming-soon'" :project="item" :key="`col_2_${index}`" :size="index % 2 === 0 ? 'lg' : 'md'"></project-grid-card>
            </template>
        </div>
        <div class="flex-[33%] flex flex-col gap-[32px]">
            <template v-for="(item, index) in projectsSortedByCategory">
                <project-grid-card v-if="[2, 5, 8, 11, 14, 17].includes(index) && item.post_title !== 'coming-soon'" :project="item" :key="`col_3_${index}`" :size="index % 2 === 0 ? 'lg' : 'md'"></project-grid-card>
            </template>
        </div>
    </div>
    <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-[32px] my-[60px]">
        <template v-for="(item, index) in projectsSortedByCategory">
            <a v-if="item.post_title === 'coming-soon'" :key="`col_1_cs_${index}`" href="/coming-soon" class="relative flex flex-col h-card-md sm:h-[520px] md:h-card-md lg:h-card-lg cta">
                <div class="order-1 banner absolute flex z-10 bottom-0 lg:bottom-auto top-0 left-0 w-full h-[56px] items-center justify-center uppercase font-bold bg-gold text-white">Bekijk toekomstige projecten</div>
                <div class="pb-[0] flex pt-[56px] relative w-full !h-full">
                    <div class="relative flex-1">
                        <img class="lazyload absolute inset-0 w-full h-full object-center object-cover" data-src="/images/coming-soon-350x420.gif" />
                    </div>
                </div>
            </a>
            <project-grid-card v-else :project="item" :key="`col_2_${index}`" size="lg"></project-grid-card>
        </template>
    </div>
</template>
